var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.475 4.375H6.525C5.4 4.375 4.5 5.25 4.5 6.23438V28.6562C4.5 29.6406 5.4 30.5156 6.525 30.5156H29.475C30.6 30.5156 31.5 29.6406 31.5 28.6562V6.23438C31.5 5.25 30.6 4.375 29.475 4.375ZM12.4875 26.6875H8.55V14.2187H12.4875V26.6875ZM10.575 12.4688C9.3375 12.4688 8.2125 11.4844 8.2125 10.1719C8.2125 8.85937 9.225 7.875 10.575 7.875C11.8125 7.875 12.9375 8.85937 12.9375 10.1719C12.9375 11.4844 11.8125 12.4688 10.575 12.4688ZM27.5625 26.5781H23.625V20.4531C23.625 19.0312 23.625 17.0625 21.4875 17.0625C19.35 17.0625 19.125 18.7031 19.125 20.2344V26.4687H15.1875V14.2187H18.9V15.8594H19.0125C19.575 14.875 20.925 13.7812 22.8375 13.7812C26.8875 13.7812 27.675 16.4062 27.675 19.7969V26.5781H27.5625Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5bbfc80d2233d76efbc6707fb47d1927.svg";
export { ForwardRef as ReactComponent };